var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mainLoading"},[_c('div',{staticClass:"imgs-container"},[_c('img',{staticClass:"img-eattake",attrs:{"src":require("../assets/eattake-horizontal-branca-png.png")}})])])
}]

export { render, staticRenderFns }